module.exports = __webpack_public_path__ + "static/media/goblin-shark.4ff4f80a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/goblin-shark.png
// module id = 315
// module chunks = 0